import { render, staticRenderFns } from "./_orders.tab.vue?vue&type=template&id=6969da0a"
import script from "./_orders.tab.vue?vue&type=script&lang=js"
export * from "./_orders.tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports